<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <!-- Tab 切換 -->
    <div class="pt-4 px-4 pb-4" style="background-color: #fff;">
      <div class="d-flex mb-0" style="border: 1px solid #777; border-radius: 8px; overflow: hidden; height: 40px; background: #fff; box-shadow: none !important;">
        <div class="flex-grow-1 text-center" style="border-radius: 6px" @click="changeTab(0)"
        :style="{ backgroundColor: activeTab === 0 ? '#4C4948' : 'transparent', color: activeTab === 0 ? 'white' : '#333', cursor: 'pointer', lineHeight: '38px', fontWeight: 'bold' }">
          {{$t('__maintenanceTab')}}
        </div>
        <div class="flex-grow-1 text-center" style="border-radius: 6px" @click="changeTab(1)"
        :style="{ backgroundColor: activeTab === 1 ? '#4C4948' : 'transparent', color: activeTab === 1 ? 'white' : '#333', cursor: 'pointer', lineHeight: '38px', fontWeight: 'bold' }">
          {{$t('__deviceTab')}}
        </div>
      </div>
    </div>
    
    <!-- 統計字卡區 (參考 Dashboard 樣式) -->
    <div class="px-4 pb-4 mb-0" v-if="displayMode === 0" style="background-color: white;">
      <div class="d-flex align-center py-4 px-2"
        style="border: 1px solid #777; border-radius: 8px; background: #fff; min-height: 100px;">
        <div v-for="(item, index) in currentStats" :key="index"
        class="flex-grow-1 px-4 d-flex align-center justify-space-between stat-card-item"
        :style="getCardStyle(item.type, index !== currentStats.length - 1)"
        @click="toggleExpiryFilter(item.type)">
          <div class="title">{{ item.label }}</div>
          <div class="value">{{ item.value }}</div>
        </div>
      </div>
    </div>

    <!-- 原始內容 -->
    <v-row v-if="displayMode === 0" class="pl-4 text-left search-bar search-bar-max ma-0">
      <v-col cols="8" class="pl-4 pr-0">
        <v-row>
          <v-btn class="ma-1 pa-0 pt-1" outlined style="border:none; height:34px; min-width:50px;  border-radius: 8px; background:#ED6D00" @click="memberSearchStatus = !memberSearchStatus">
            <v-icon color="white" size="20">mdi-filter-menu-outline</v-icon>
          </v-btn>
          <v-list v-if="memberSearchStatus" class="py-4 mt-10" style="position: absolute; z-index: 100; border-radius: 8px;">
            <v-list-item>
              <div class="text-right pt14" style="width:80px">{{$t('__customer')}}</div>
              <v-text-field class="border pt14 pl-4 clickable-field" dense background-color="white" outlined :placeholder="$t('__select')"
              :value="customerSel" readonly hide-details clearable @click="openCustomerDialog" @click:clear="customerSel = ''" style="max-width:196px; cursor: pointer;"></v-text-field>
            </v-list-item>
            <v-list-item>
              <div class="text-right pt14" style="width:80px">{{$t('__status')}}</div>
              <v-select class="border pt14 pl-4" dense background-color="white" outlined :placeholder="$t('__select')" style="max-width:196px"
              :items="memberStatusList" :item-text="'CodeText'" item-value="CodeText" v-model="memberStatusSel"></v-select>
            </v-list-item>
          </v-list>
          <v-col class="pa-0 col-5 d-flex align-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="#ED6D00" size="18" class="mr-2" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span style="white-space: pre-line; text-align: left; display: block;">{{ activeTab === 0 ? $t('__keywordSearchMaintenanceTooltip') : $t('__keywordSearchDeviceTooltip') }}</span>
            </v-tooltip>
            <v-text-field outlined :placeholder="$t('__keywordSearch')" class="keyword text_field"
            dense v-model="keyword" background-color="white" style="margin-top: 4px; flex-grow: 1;">
              <template v-slot:append>
                <v-icon class="my-1" color="white" style="background:#ED6D00" @click="search">
                icon-form_search
                </v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-btn class="ma-1 pa-0 py-1" outlined style="border:none; height:34px; min-width:50px;  border-radius: 8px; background:#777" @click="close()">
            <v-icon color="white" size="20">mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-col>
      <v-col cols="4" class="pr-8 pl-0">
        <v-row justify="end" align="center">
          <!-- Export Excel -->
          <v-btn class="ma-1 pa-0" outlined :title="$t('__exportExcel')"
            style="border:none; height:34px; min-width:40px; border-radius: 8px; background:#ED6D00"
            @click="exportExcel">
            <v-icon color="white" size="22">mdi-cloud-download-outline</v-icon>
          </v-btn>
          <!-- Import Excel -->
          <v-btn v-if="canEdit" class="ma-1 pa-0" outlined :title="$t('__importExcel')"
            style="border:none; height:34px; min-width:40px; border-radius: 8px; background:#ED6D00"
            @click="$refs.ImportFile.open((activeTab === 0 ? 'maintenance' : 'device'),true)">
            <v-icon color="white" size="20">mdi-cloud-upload-outline</v-icon>
          </v-btn>
          <v-btn v-if="canEdit" class="search-bar-btn" style="color:#FFF" outlined @click="redirectPath(-1)">
            <span>{{ activeTab === 0 ? $t('__newMaintenance') : $t('__newDevice') }}</span>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-if="displayMode === 1" class="text-left search-bar ma-0 pa-0 search-bar-min">
      <v-expansion-panels accordion style="z-index: 3">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-icon class="ml-0 mr-3">icon-form_search</v-icon>
            {{$t('__categorySearch')}}
            <template v-slot:actions>
              <v-icon>$expand</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <v-row justify="center">
                <v-btn class="ma-1 pa-0 pt-1" outlined style="border:none; height:34px; min-width:50px;  border-radius: 8px; background:#ED6D00" @click="memberSearchStatus = !memberSearchStatus">
                  <v-icon color="white" size="20">mdi-filter-menu-outline</v-icon>
                </v-btn>
                <v-list v-if="memberSearchStatus" class="py-4 mt-10" style="position: absolute; z-index: 100; border-radius: 8px;">
                  <v-list-item>
                    <div class="text-right pt14" style="width:80px">{{$t('__customer')}}</div>
                    <v-text-field class="border pt14 pl-4 clickable-field" dense background-color="white" outlined :placeholder="$t('__select')"
                    :value="customerSel" readonly hide-details clearable @click="openCustomerDialog" @click:clear="customerSel = ''" style="max-width:196px; cursor: pointer;"></v-text-field>
                  </v-list-item>
                  <v-list-item>
                    <div class="text-right pt14" style="width:80px">{{$t('__status')}}</div>
                    <v-select class="border pt14 pl-4" dense background-color="white" outlined :placeholder="$t('__select')" style="max-width:196px"
                    :items="memberStatusList" :item-text="'CodeText'" item-value="CodeText" v-model="memberStatusSel"></v-select>
                  </v-list-item>
                </v-list>
                <v-col class="pa-0 col-7 d-flex align-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="#ED6D00" size="18" class="mr-2" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                    </template>
                    <span style="white-space: pre-line; text-align: left; display: block;">{{ activeTab === 0 ? $t('__keywordSearchMaintenanceTooltip') : $t('__keywordSearchDeviceTooltip') }}</span>
                  </v-tooltip>
                  <v-text-field outlined :placeholder="$t('__keywordSearch')" class="keyword text_field"
                  dense v-model="keyword" background-color="white" style="margin-top: 4px; flex-grow: 1;">
                    <template v-slot:append>
                      <v-icon class="my-1" color="white" style="background:#ED6D00" @click="search">
                      icon-form_search
                      </v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-btn class="ma-1 pa-0 py-1" outlined style="border:none; height:34px; min-width:50px;  border-radius: 8px; background:#777" @click="close()">
                  <v-icon color="white" size="20">mdi-close</v-icon>
                </v-btn>
              </v-row>
              <v-divider class="d-md-none"></v-divider>
              <v-row class="justify-center pt-1">
                <v-btn v-if="canEdit" class="search-bar-btn" style="color:#FFF" outlined @click="redirectPath(-1)">
                  <span>{{ activeTab === 0 ? $t('__newMaintenance') : $t('__newDevice') }}</span>
                </v-btn>
              </v-row>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>

    <v-row id="router" class="ma-0 pa-0">
      <div id="listTable">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr class="text-center" v-if="activeTab === 0">
                <th class="text-center">{{$t('__edit')}}</th>
                <th @click="sort('id')">{{$t('__no')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('serialNumber')">{{$t('__serialNumber')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('customer')">{{$t('__customer')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('groupName')">{{$t('__group')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('contractNumber')">{{$t('__contractNumber')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('contractCurrency')">{{$t('__contractCurrency')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('startDateString')">{{$t('__startDate')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('endDateString')">{{$t('__endDate')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('status')">{{$t('__contactStatus')}}<v-icon small>icon-form_sort_off</v-icon></th>
              </tr>
              <tr class="text-center" v-if="activeTab === 1">
                <th class="text-center">{{$t('__edit')}}</th>
                <th @click="sort('id')">{{$t('__no')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('type')">{{$t('__type')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('serialNumber')">{{$t('__serialNumber')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('customer')">{{$t('__customer')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('groupName')">{{$t('__group')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('projectId')">{{$t('__projectId')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('projectName')">{{$t('__project')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('startDateString')">{{$t('__startDate')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('endDateString')">{{$t('__endDate')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('status')">{{$t('__status')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <!-- Device 專屬欄位請在此增加 -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data,index) in datasets" :key="index" id="table_body">
                <td class="text-center" style="min-width:160px">
                  <!-- 顯示所有業務名稱 -->
                  <!-- <h4 class="content flex-grow-1">{{ salesNames(data.sales).join(', ') }}</h4> -->
                  <!-- 只要有至少一人就顯示圖標 -->
                  <div v-if="activeTab === 0" style="display: inline-block; width: 34px; vertical-align: middle;">
                    <v-menu v-if="salesNames(data.sales).length > 0"
                  bottom open-on-hover offset-y :close-delay="200" content-class="sales-contact-tooltip" transition="fade-transition" z-index="1000">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="sales-mail-btn" icon color="#ED6D00" v-bind="attrs" v-on="on" @click.stop="">
                        <v-icon size="20" color="white">mdi-email-edit-outline</v-icon>
                      </v-btn>
                    </template>
                    <!-- tooltip 內容：每個業務各一區塊 -->
                    <v-card class="pa-2 sales-tooltip-content" elevation="0">
                      <div v-for="(name, idx) in salesNames(data.sales)" :key="idx">
                        <v-divider v-if="idx > 0" class="my-2"></v-divider>
                        <div class="sales-tooltip-header" :class="{ 'mb-1': true }">
                          <strong>{{ name }}</strong>
                        </div>
                        <v-divider class="mb-1"></v-divider>
                        <template v-if="getSalesContact(name)">
                          <div class="d-flex align-center mb-1 sales-tooltip-item clickable-tooltip-item" :title="$t('__clickCopy')"
                          @click.stop="copyToClipboard(getSalesContact(name).email)">
                            <v-icon small color="#555" class="mr-2">mdi-email-outline</v-icon>
                            <span class="selectable-text">{{ getSalesContact(name).email || '-' }}</span>
                          </div>
                          <div class="d-flex align-center sales-tooltip-item clickable-tooltip-item" :title="$t('__clickCopy')"
                          @click.stop="copyToClipboard(getSalesContact(name).phone)">
                            <v-icon small color="#555" class="mr-2">mdi-phone</v-icon>
                            <span class="selectable-text">{{ getSalesContact(name).phone || '-' }}</span>
                          </div>
                        </template>
                        <template v-else>
                          <div class="sales-tooltip-item" style="color:#bbb; font-style:italic;">{{ $t('__noEmployeesFound') }}</div>
                        </template>
                      </div>
                    </v-card>
                    </v-menu>
                  </div>
                  <v-avatar color="#ED6D00" size="30" tile @click="redirectPath(data.encryptedId || data.id)" 
                    class="ml-1 action-btn-edit" style="cursor: pointer;">
                    <v-icon color="#FFFFFF" size="28">icon-form_edit_tap</v-icon>
                  </v-avatar>
                  <v-avatar v-if="canEdit" color="#4C4948" size="30" tile @click="confirmDelete(data.id)"
                    class="ml-1 action-btn-delete" style="cursor: pointer;">
                    <v-icon color="#FFFFFF" size="20">mdi-delete</v-icon>
                  </v-avatar>
                </td>
                <template v-if="activeTab === 0">
                  <td style="min-width:95px"><h4 class="content">{{data.id}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.serialNumber}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.customer}}</h4></td>
                  <td style="min-width:130px"><h4 class="content">{{data.groupName}}</h4></td>
                  <td style="min-width:110px"><h4 class="content">{{data.contractNumber}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.contractCurrency}}</h4></td>
                  <!-- <td style="min-width:120px"><h4 class="content">{{formatDate(data.startDate, data.startDateString)}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{formatDate(data.endDate, data.endDateString)}}</h4></td> -->
                  <td style="min-width:120px"><h4 class="content">{{data.startDateString}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.endDateString}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.status}}</h4></td>
                </template>
                <template v-if="activeTab === 1">
                  <td style="min-width:95px"><h4 class="content">{{data.id}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{getTypeDisplay(data.type)}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.serialNumber}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.customer}}</h4></td>
                  <td style="min-width:130px"><h4 class="content">{{data.groupName}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.projectId}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.projectName}}</h4></td>
                  <!-- <td style="min-width:120px"><h4 class="content">{{formatDate(data.startDate, data.startDateString)}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{formatDate(data.endDate, data.endDateString)}}</h4></td> -->
                  <td style="min-width:120px"><h4 class="content">{{data.startDateString}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.endDateString}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.status}}</h4></td>
                  <!-- Device 專屬資料列內容請在此增加 -->
                </template>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    
      <v-row class="ma-0 px-4 justify-center justify-lg-end">
        <v-col cols="12" lg="6" class="pa-0"></v-col>
        <v-col cols="12" lg="6">
          <v-row class="ma-0 align-center" style="justify-content: center">
            <v-col cols="12" lg="auto" class="d-none d-lg-flex align-center">
              {{ $tc('__totalCount', pagination.totalCount, { count: pagination.totalCount }) }}
            </v-col>
            <v-col cols="12" lg="auto" class="d-flex justify-center">
              <v-pagination color="#ED6D00" :total-visible="5" :length="pagination.totalPage" v-model="pagination.page"/>
            </v-col>
            <v-col cols="12" lg="auto" class="d-flex justify-center justify-lg-end align-center">
              <span class="mr-2">{{ $t('__go') }}</span>
              <v-text-field class="mx-1 text-center" min="1" :max="pagination.totalPage" type="number"
              dense outlined hide-details style="max-width: 80px" @keyup.enter="setDestPage()" v-model="destPage"/>
              <span class="ml-1">{{ $t('__page') }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
    <ImportFile ref="ImportFile" :onSave="onImportFile" />
    <ShowConfirm ref="ShowConfirm" :onSave="deleteRecord" />
    <ShowMsg ref="ShowMsg" />

    <!-- Import Result Dialog -->
    <v-dialog v-model="showImportResult" max-width="500" persistent>
      <v-card class="pa-3">
        <div class="close-dialog-btn mt-2" style="top: 22px">
          <v-icon color="#D8DDE4" @click="showImportResult = false">mdi-close</v-icon>
        </div>
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          {{ $t('__importResultTitle') }}
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; font-size:15px">
          {{ importResultMessage }}
          <div v-if="importResultData && importResultData.errors && importResultData.errors.length > 0" class="mt-3">
            <div style="color:#ED6D00; margin-bottom:4px;">{{ $t('__importErrors') }}</div>
            <div v-for="(err, idx) in importResultData.errors" :key="idx" style="color:#b71c1c; font-size:13px;">{{ err }}</div>
          </div>
        </v-card-text>
        <v-row justify="center">
          <v-card-actions class="mb-2 px-3" style="justify-content:center">
            <v-btn class="colorBtn primary-color-background" outlined color="#FFF" @click="showImportResult = false; getDataset();">
              {{ $t('__confirm') }}
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
    <CustomerSelectDialog ref="customerSelectDialog" @confirm="onCustomerSelected" />
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import ImportFile from '@/dialogs/ImportFile'
import ShowConfirm from '@/dialogs/ShowConfirm'
import ShowMsg from '@/dialogs/ShowMsg'
import CustomerSelectDialog from '@/dialogs/CustomerSelectDialog'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'
import { getEmployeeInfo } from '@/utils/auth'

export default {
  name: 'WarrantyAndMaintenance',
  components: {ImportFile, ShowConfirm, ShowMsg, Loading, CustomerSelectDialog},
  mounted(){
    this.language = i18n.locale
    // 載入員工列表供查詢業務聨簿資訊
    this.$http({ method: 'GET', url: '/EmployeeList', params: { pageSize: 9999, currentPage: 1, orderBy: 'name', isNamePriority: true, direction: 'asc' } })
      .then(res => { this.employeeList = res.data.Data || res.data.data || [] })
      .catch(() => {})
    
    // Restore tab: priority URL query > sessionStorage
    if (this.$route.query.tab !== undefined) {
      this.activeTab = parseInt(this.$route.query.tab)
      sessionStorage.setItem('warrantyTab', this.activeTab)
    } else {
      const savedTab = sessionStorage.getItem('warrantyTab')
      if (savedTab !== null) {
        this.activeTab = parseInt(savedTab)
      }
    }

    this.getDataset()
    this.destPage = this.pagination.page

    // 初始化統計資料 (API 內部會自動處理提醒天數設定)
    this.fetchMaintenanceStats()
    this.fetchDeviceStats()

    // 處理來源路由的過濾參數
    if (this.$route.query.filter) {
      this.expiryFilter = this.$route.query.filter
      // getDataset will be called by watchers if needed, but since we already called it once, 
      // and getDataset handles expiryFilter, we might need a refresh.
      this.getDataset()
    }
    this.initializeLists()
  },
  data:() => ({
    activeTab: 0,
    select:'',
    keyword:'',
    language:'',
    isLoading: false,
    datasets: [],
    employeeList: [],  // 供查詢業務聨簿資訊
    pagination:{page:1,totalPage:1,totalCount:0},
    pageSize: 10,
    orderBy:'id',
    direction:'desc',
    destPage:'',
    viewStyle:{},
    displayMode:'',

    customerList: [],
    customerSel:'',
    languageList: [],
    memberStatusList: [
      { CodeText: 'Upcoming' },
      { CodeText: 'Expired' },
      { CodeText: 'Active' }
    ],
    memberStatusSel:'',

    memberSearchStatus: false,
    deleteId: null,
    
    // Expiry Stats
    maintenanceReminderDays: 30,
    deviceReminderDays: 30,
    maintenanceStats: { expiringX: 0, expired: 0 },
    deviceStats: { expiringY: 0, expired: 0, maintenanceExpiring: 0, maintenanceExpired: 0 },
    expiryFilter: null, // 'Upcoming' | 'Expired' | 'MaintenanceUpcoming' | 'MaintenanceExpired' | null
    fullDatasets: [],   // 用於前端過濾

    // Excel import result
    showImportResult: false,
    importResultMessage: '',
    importResultData: null,
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
    this.$root.$on('language',(value)=>{
      this.language = value
    })
  },
  watch:{
    "pagination.page":function(val){
      this.destPage = val
      this.getDataset()
    },
    "memberStatusSel":function(val){
      if (val) {
        this.expiryFilter = null
      }
      this.getDataset()
    },
    "customerSel":function(){
      this.getDataset()
    },
    "keyword":function(){
      this.getDataset()
    },
    "expiryFilter": function() {
      this.getDataset()
    },
    "$route.query.tab": {
      handler: function(val) {
        if (val !== undefined) {
          const tabIndex = parseInt(val)
          if (this.activeTab !== tabIndex) {
            this.activeTab = tabIndex
            sessionStorage.setItem('warrantyTab', tabIndex)
            this.pagination.page = 1
            this.getDataset()
          }
        }
      },
      immediate: false
    },
    "$route.query.filter": {
      handler: function(val) {
        if (val !== undefined) {
          this.expiryFilter = val
          this.getDataset()
        }
      },
      immediate: false
    }
  },
  computed: {
    currentStats() {
      if (this.activeTab === 0) {
        return [
          {
            type: 'Upcoming',
            label: this.$t('__maintenanceExpired30', { days: this.maintenanceReminderDays }),
            value: this.maintenanceStats.expiringX
          },
          {
            type: 'Expired',
            label: this.$t('__maintenanceExpired'),
            value: this.maintenanceStats.expired
          }
        ]
      } else {
        return [
          {
            type: 'MaintenanceUpcoming',
            label: this.$t('__maintenanceExpired30', { days: this.maintenanceReminderDays }),
            value: this.deviceStats.maintenanceExpiring
          },
          {
            type: 'MaintenanceExpired',
            label: this.$t('__maintenanceExpired'),
            value: this.deviceStats.maintenanceExpired
          },
          {
            type: 'Upcoming',
            label: this.$t('__deviceExpired30', { days: this.deviceReminderDays }),
            value: this.deviceStats.expiringY
          },
          {
            type: 'Expired',
            label: this.$t('__deviceExpired'),
            value: this.deviceStats.expired
          },
        ]
      }
    },
    canEdit() {
      try {
        const info = getEmployeeInfo()
        if (info && info.function) {
          const perms = JSON.parse(info.function)
          const p = perms.find(e => e.key === 'WarrantyAndMaintenance')
          return p ? !!p.edit : false
        }
      } catch (e) {
        console.error('Failed to parse permissions:', e)
      }
      return false
    }
  },
  methods:{
    openCustomerDialog() {
      this.$refs.customerSelectDialog.open(this.customerSel)
    },
    onCustomerSelected(customer) {
      this.customerSel = customer ? customer.name : ''
    },
    close(){
      this.keyword = ''
      this.customerSel = ''
      this.memberStatusSel = ''
    },
    initializeLists() {
      var self = this
      // Fetch data for dropdowns
      this.$http.get('/GetCustomerList').then(response => {
        const data = response.data.Data || response.data.data || response.data || []
        if (Array.isArray(data)) {
          // self.customerDataList = data  // Store full objects for auto-fill
          self.customerList = data.map(item => item.name)
        }
      })
    },
    getSalesContact(name) {
      if (!name || !this.employeeList.length) return null
      const emp = this.employeeList.find(e => (e.name || '').trim() === name.trim())
      if (!emp) return null
      return {
        email: emp.account || emp.email || emp.mail || '',
        phone: emp.phone || emp.mobile || ''
      }
    },
    copyToClipboard(text) {
      if (!text || text === '-') return
      navigator.clipboard.writeText(text).catch(err => {
        console.error('Copy failed:', err)
      })
    },
    salesNames(sales) {
      // 統一標準化：array / JSON string / 純字串 都轉為純粹名稱陣列
      if (!sales) return []
      if (Array.isArray(sales)) return sales.filter(n => n && n.trim())
      if (typeof sales === 'string') {
        // 嘗試解析 JSON string
        try {
          const parsed = JSON.parse(sales)
          if (Array.isArray(parsed)) return parsed.filter(n => n && n.trim())
        } catch (e) {}
        // 純字串（單一名稱）
        return sales.trim() ? [sales.trim()] : []
      }
      return []
    },
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-200 + 'px'}
      if(window.innerWidth >= 960){
        this.displayMode = 0
      } else {
        this.displayMode = 1
      }
    },
    redirectPath(id){
      let targetId = (typeof id === 'object' && id !== null) ? (id.encryptedId || id.id) : id
      let tmp = {
        keyword: this.keyword,
        customerSel: this.customerSel,
        memberStatusSel: this.memberStatusSel,
      }
      sessionStorage.setItem('search',JSON.stringify(tmp))
      var path = this.activeTab === 0 ? '/maintenance' : '/device'
      this.$router.push({path: path, query: {id: targetId, page: this.pagination.page, tab: this.activeTab}})
    },
    setDestPage(){
      let page = parseInt(this.destPage)
      if (isNaN(page) || page < 1) {
        page = 1
      }
      if (page > this.pagination.totalPage) {
        page = this.pagination.totalPage
      }
      this.destPage = page
      if (this.pagination.page === page) {
        this.getDataset()
      } else {
        this.pagination.page = page
      }
    },
    sort(field){
      this.orderBy = field
      this.direction = (this.direction == 'desc') ? 'asc' : 'desc'
      this.getDataset()
    },
    search(){
      (this.pagination.page == 1) ? this.getDataset() : this.pagination.page = 1
    },
    toggleExpiryFilter(type) {
      if (this.expiryFilter !== type) {
        this.close()
      }

      this.expiryFilter = this.expiryFilter === type ? null : type

      this.pagination.page = 1
      this.getDataset()
    },
    getCardStyle(type, hasBorder) {
      return {
        cursor: 'pointer',
        borderRight: hasBorder ? '1px solid #eee' : 'none',
        opacity: (this.expiryFilter === type || !this.expiryFilter) ? 1 : 0.4
      }
    },
    parseDate(val1, val2, val3) {
      const target = val1 || val2 || val3
      if (!target || typeof target !== 'string') return null
      
      const dStr = target.substr(0, 10).replace(/\//g, '-')
      const parts = dStr.split('-')
      if (parts.length === 3) {
        return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]))
      }
      return null
    },

    fetchMaintenanceStats() {
      this.$http({
        method: 'GET',
        url: '/GetMaintenanceExpiryStats'
      }).then(res => {
        const data = res.data?.Data || {}
        this.maintenanceStats = { 
          expiringX: data.expiringCount || 0, 
          expired: data.expiredCount || 0 
        }
        this.maintenanceReminderDays = data.reminderDays || 30
      }).catch(() => {})
    },
    fetchDeviceStats() {
      this.$http({
        method: 'GET',
        url: '/GetDeviceExpiryStats'
      }).then(res => {
        const data = res.data?.Data || {}
        this.deviceStats = { 
          expiringY: data.expiringCount || 0, 
          expired: data.expiredCount || 0,
          maintenanceExpiring: data.maintenanceExpiringCount || 0,
          maintenanceExpired: data.maintenanceExpiredCount || 0
        }
        this.deviceReminderDays = data.reminderDays || 30
      }).catch(() => {})
    },
    changeTab(tabIndex) {
      if (this.activeTab === tabIndex) return
      this.activeTab = tabIndex
      sessionStorage.setItem('warrantyTab', tabIndex)
      this.expiryFilter = null
      this.pagination.page = 1
      this.datasets = []
      this.getDataset()
    },
    // formatDate(isoDate, fallbackStr) {
    //   if (isoDate && typeof isoDate === 'string') {
    //     return isoDate.substr(0, 10).replace(/\//g, '-')
    //   }
    //   if (fallbackStr && typeof fallbackStr === 'string') {
    //     return fallbackStr.substr(0, 10).replace(/\//g, '-')
    //   }
    //   return ''
    // },
    getDataset(){
      var self = this
      this.isLoading = true
      this.datasets = []
      var url = self.activeTab === 0 ? '/GetMaintenanceList' : '/GetDeviceList'
      
      // 處理到期過濾
      let statusParam = self.memberStatusSel || null;
      let quickFilter = null;
      let quickFilterDays = null;
      
      if (self.expiryFilter) {
        if (self.activeTab === 1) {
          // 設備頁籤使用 quickFilter
          if (self.expiryFilter === 'Upcoming') {
            quickFilter = 'WarrantyUpcoming';
            quickFilterDays = self.deviceReminderDays;
          } else if (self.expiryFilter === 'Expired') {
            quickFilter = 'WarrantyExpired';
          } else if (self.expiryFilter === 'MaintenanceUpcoming') {
            quickFilter = 'MaintenanceUpcoming';
            quickFilterDays = self.maintenanceReminderDays;
          } else if (self.expiryFilter === 'MaintenanceExpired') {
            quickFilter = 'MaintenanceExpired';
          }
          statusParam = null; // 使用 quickFilter 時不帶 statusParam
        } else {
          // 維護合約頁籤維持現有邏輯
          statusParam = self.expiryFilter;
        }
      }

      var request = {
        method: 'GET',
        url: url,
        params: {
          'orderBy': self.orderBy,
          'direction': self.direction,
          'pageSize': self.pageSize,
          'currentPage': self.pagination.page,
          'keyword': self.keyword != '' ? self.keyword : null,
          'customer': self.customerSel != '' ? self.customerSel : null,
          'status': statusParam,
          'quickFilter': quickFilter,
          'quickFilterDays': quickFilterDays
        },
      }

      this.$http(request).then(function(response) {
        self.datasets = response.data.Data || []
        self.pagination.totalPage = response.data.TotalPageCount
        self.pagination.totalCount = response.data.TotalCount
      }).catch(()=>{
        alert(this.$t('__systemError', { code: 'Wam-7971' }))
      }).finally(() => {
        self.isLoading = false
      })
    },
    confirmDelete(id) {
      // Store the ID and show confirmation dialog
      this.deleteId = id
      this.$refs.ShowConfirm.open(2, null, null, true)
    },
    deleteRecord() {
      if (!this.deleteId) return
      
      var self = this
      // Use different API based on active tab
      var url = this.activeTab === 0 ? '/DeleteMaintenance' : '/DeleteDevice'
      
      var request = {
        method: 'POST',
        url: url,
        headers: {
          'Content-Type': 'application/json-patch+json'
        },
        data: {
          id: this.deleteId
        }
      }
      
      this.$http(request).then(function(response) {
        // Reset delete ID
        self.deleteId = null
        
        // Refresh the list
        self.getDataset()
        
        // Show success message using ShowMsg component
        self.$refs.ShowMsg.open(4) // type 4 = delete success
      }).catch((error) => {
        console.error('Delete error:', error)
        var errorMsg = error.response?.data?.Message || '刪除失敗'
        // Show error message using ShowMsg component
        self.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
        self.deleteId = null
      })
    },
    exportExcel() {
      var self = this
      var url = this.activeTab === 0 ? '/ExportMaintenanceExcel' : '/ExportDeviceExcel'
      this.$http({
        method: 'GET',
        url: url,
        params: { languageSetting: this.language },
        responseType: 'blob'
      }).then(function(response) {
        // Support both raw blob response and axios response object
        var blob = response instanceof Blob ? response : (response.data instanceof Blob ? response.data : new Blob([response.data]))
        var fileName = self.activeTab === 0 ? 'MaintenanceExport.xlsx' : 'DeviceExport.xlsx'
        // Try to get filename from content-disposition header
        var disposition = response.headers && response.headers['content-disposition']
        if (disposition) {
          var match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
          if (match && match[1]) fileName = match[1].replace(/['"]/g, '')
        }
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(link.href)
      }).catch((error) => {
        var errorMsg = error.response?.data?.Message || '匯出失敗'
        self.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
      })
    },
    onImportFile(){
      this.getDataset()
    },
    getTypeDisplay(type) {
      if (type === 'Rent') return this.$t('__rental')
      if (type === 'Sold') return this.$t('__sold')
      // Fallback for legacy Chinese data or unexpected values
      if (type === '租賃') return this.$t('__rental')
      if (type === '出售') return this.$t('__sold')
      return type
    }
  }
}
</script>

<style>
  @media (min-width: 960px) {
    .search-bar-min {
      display: none !important;
    }
  }
  @media (max-width: 959px) {
    .search-bar-max, .pagination-max {
      display: none !important;
    }
  }
  
  /* Action buttons hover effects */
  .action-btn-edit:hover {
    opacity: 0.8;
    transition: opacity 0.2s;
  }
  
  .action-btn-delete:hover {
    opacity: 0.8;
    transition: opacity 0.2s;
  }

  /* Sales Contact Tooltip */
  .sales-contact-tooltip {
    opacity: 1 !important;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;
    border-radius: 12px !important;
    padding: 0 !important;
    border: 1px solid #eee !important;
  }
  .sales-tooltip-content {
    color: #444;
    min-width: 200px;
    background-color: white !important;
  }
  .sales-tooltip-header {
    font-size: 15px;
    color: #444;
    text-align: center;
    padding: 4px 12px;
  }
  .sales-tooltip-item {
    font-size: 13px;
    padding: 3px 12px;
  }
  .sales-mail-btn {
    background-color: #ED6D00 !important;
    width: 30px !important;
    height: 30px !important;
    border-radius: 8px !important;
    flex-shrink: 0;
  }
  .clickable-tooltip-item {
    cursor: pointer !important;
    transition: background-color 0.2s;
    border-radius: 6px;
  }
  .clickable-tooltip-item:hover {
    background-color: #f0f0f0;
  }
  .selectable-text {
    user-select: text !important;
    cursor: text;
    word-break: break-all;
  }
  .title {
    font-size: 18px;
    font-weight: bold;
    color: #666;
  }
  .value {
    font-size: 36px;
    font-weight: bold;
    color: #4FA8D1;
    margin-left: 20px;
  }

  .centered-input >>> input {
    text-align: center;
  }
  .centered-input >>> input[type=number] {
    -moz-appearance: textfield;
  }
</style>